import { useCallback } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../../api/adminApi";
import InvestorInvestmentsGrid from "./InvestorInvestmentsGrid";

interface Props {
  investorId: string;
  reportingDate: string;
}

const InvestorInvestmentsData = ({ investorId, reportingDate }: Props) => {
  const fetchInvestments = useCallback(
    (signal?: AbortSignal) => adminApi.getInvestorInvestments(investorId, { reportingDate }, signal),
    [investorId, reportingDate]
  );

  const [investments, error] = useFetch(fetchInvestments);

  if (error) {
    logError(error, "[InvestorInvestmentsData] getInvestorInvestments");
    return <DataLoadingFailed title="Loading investor investments failed" />;
  }

  if (investments === undefined) {
    return <InlineLoader />;
  }

  return <InvestorInvestmentsGrid investments={investments} />;
};

export default InvestorInvestmentsData;
